import { render } from "./donations.vue?vue&type=template&id=12b483f6&scoped=true"
import script from "./donations.vue?vue&type=script&lang=js"
export * from "./donations.vue?vue&type=script&lang=js"

import "./donations.vue?vue&type=style&index=0&id=12b483f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b483f6"]])

export default __exports__